import moment from 'moment'

export default {
  methods: {
    formatDate (date, format = 'YYYY-MM-DD', defaultValue = null) {
      return date !== null && date !== undefined ? moment.parseZone(date).format(format) : defaultValue
    },
    getMemberName (row) {
      return row.heirs.map(item => {
        const prefix = item.primaryHeir ? '(代)' : '(相)'
        const name = item.member.lastName + ' ' + item.member.firstName
        return prefix + ' ' + name
      }).join('\n')
    },
    zenhan (a) {
      // 10進数の場合
      a = a.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
        return String.fromCharCode(
          s.charCodeAt(0) - 65248
        )
      })

      // 16進数の場合
      a = a.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
        return String.fromCharCode(
          s.charCodeAt(0) - 0xFEE0
        )
      })
      return a
    },
    handleInputNumberOnly (evt) {
      let charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) { evt.preventDefault() }
    }
  },
  numbersToKanji (num) {
    if (num === undefined || num === null || num === '') {
      return ''
    }
    if (!(/^-?[0-9]+$/g.test(num))) {
      throw new TypeError('半角数字以外の文字が含まれています。漢数字に変換できませんでした。-> ' + num)
    }
    num = Number(num)
    if (!Number.isSafeInteger(num)) {
      throw new RangeError('数値が ' + Number.MIN_SAFE_INTEGER + ' ～ ' + Number.MAX_SAFE_INTEGER + ' の範囲外です。漢数字に変換できませんでした。-> ' + num)
    }
    if (num === 0) {
      return '零'
    }
    let ret = ''
    if (num < 0) {
      ret += 'マイナス'
      num *= -1
    }
    const kanjiNums = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九']
    const kanjiNames = ['十', '百', '千', '万', '億', '兆', '京', '垓', '𥝱', '穣', '溝', '澗', '正', '載', '極', '恒河沙', '阿僧祇', '那由他', '不可思議', '無量大数']
    const exponents = [1, 2, 3, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68]
    const exponentsLen = exponents.length
    for (let i = exponentsLen; i >= 0; --i) {
      const bias = Math.pow(10, exponents[i])
      if (num >= bias) {
        const top = Math.floor(num / bias)
        if (top >= 10) {
          // eslint-disable-next-line no-undef
          ret += numbersToKanji(top)
        } else {
          // eslint-disable-next-line eqeqeq
          if (top === 1 && exponents[i] <= 3) {
            // ※先頭の数字が1、かつ指数が3 (千の位) 以下の場合のみ『一』をつけない
          } else {
            ret += kanjiNums[top]
          }
        }
        ret += kanjiNames[i]
        num -= top * bias
      }
    }
    ret += kanjiNums[num]
    return ret
  }
}
